Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DTextureFilter = module.exports.default = {
	ANISOTROPIC16X: "anisotropic16x",
	ANISOTROPIC2X: "anisotropic2x",
	ANISOTROPIC4X: "anisotropic4x",
	ANISOTROPIC8X: "anisotropic8x",
	LINEAR: "linear",
	NEAREST: "nearest"
};